var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _vm._v(_vm._s(_vm.$t("message.menu.edit_profile")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body px-1" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("message.profile.email")) + ":")
            ]),
            _vm._v(" " + _vm._s(_vm.user.email) + "\n        ")
          ]),
          _vm._v(" "),
          _vm.user && _vm.user.platform
            ? _c("div", { staticClass: "col-12" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("message.profile.registeredMethod")) + ":"
                  )
                ]),
                _vm._v(" " + _vm._s(_vm.user.platform) + "\n        ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "control-label col-sm-2" }, [
            _vm._v(_vm._s(_vm.$t("message.profile.picture")) + ":")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-10" },
            [
              _c("img", {
                staticClass: "img-fluid rounded-circle",
                attrs: { src: _vm.user.picture, width: "160" }
              }),
              _c("br"),
              _vm._v(" "),
              _c("vue-core-image-upload", {
                staticClass: "btn btn-secondary mt-3",
                attrs: {
                  extensions: "png,jpeg,jpg",
                  crop: false,
                  "max-file-size": 5242880,
                  headers: _vm.headers,
                  credentials: false,
                  url: _vm.url,
                  disabled: _vm.uploading,
                  text: _vm.$t(_vm.isUploading)
                },
                on: {
                  imageuploaded: _vm.imageUploaded,
                  imageuploading: _vm.imageUploading,
                  errorhandle: _vm.errorHandle
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "firstName" } }, [
                _vm._v(_vm._s(_vm.$t("message.profile.firstname")) + ":")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.firstName,
                    expression: "formData.firstName"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "firstName",
                staticClass: "form-control",
                class: { "form-alert": _vm.errors.has("firstName") },
                attrs: { type: "text", id: "firstName", name: "firstName" },
                domProps: { value: _vm.formData.firstName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.formData, "firstName", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.errors.has("firstName")
                ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("message.required_field")) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-6" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "lastName" } }, [
                _vm._v(_vm._s(_vm.$t("message.profile.lastname")) + ":")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.lastName,
                    expression: "formData.lastName"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "lastName",
                staticClass: "form-control",
                class: { "form-alert": _vm.errors.has("firstName") },
                attrs: { type: "text", id: "lastName", name: "lastName" },
                domProps: { value: _vm.formData.lastName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.formData, "lastName", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.errors.has("lastName")
                ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("message.required_field")) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "tel" } }, [
                _vm._v(_vm._s(_vm.$t("message.profile.phone")) + ":")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.tel,
                    expression: "formData.tel"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: true,
                      min: 10,
                      max: 15,
                      regex: /^\+?[0-9-]+$/
                    },
                    expression:
                      "{ required: true, min: 10, max: 15, regex: /^\\+?[0-9-]+$/ }"
                  }
                ],
                ref: "tel",
                staticClass: "form-control",
                class: { "form-alert": _vm.errors.has("tel") },
                attrs: { type: "tel", id: "tel", name: "tel" },
                domProps: { value: _vm.formData.tel },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.formData, "tel", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.errors.has("tel")
                ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("message.required_field")) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info btn-block",
                attrs: { disabled: _vm.userState.isUpdating },
                on: { click: _vm.saveUserData }
              },
              [_vm._v(_vm._s(_vm.$t(_vm.isUpdating)) + "\n          ")]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _vm._v(_vm._s(_vm.$t("message.delete_account.title")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn btn-outline-danger",
              attrs: { to: "/delete-account" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.delete_account.title")) +
                  "\n      "
              )
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [_c("hr")])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b6fba6b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6fba6b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/EditProfile.vue
// module id = 1799
// module chunks = 0